import { useEffect, useState } from "react"
import { useService } from "./context/useService"
import { useSupabase } from "./context/useSupabase"

export const BRAZILIAN_CREDIT_BONDS_TYPE = [
  {
    label: "% DI",
    value: "DI_PERCENTUAL",
    legend: (value) => `${value.toFixed(2)}% CDI`,
  },
  {
    label: "DI+",
    value: "DI_SPREAD",
    legend: (value) => `CDI + ${value.toFixed(2)}%`,
  },
  {
    label: "IPCA+",
    value: "IPCA_SPREAD",
    legend: (value) => `IPCA + ${value.toFixed(2)}%`,
  },
]

export const useBrazilianCreditBonds = () => {
  const [date, setDate] = useState(null)
  const [availableDates, setAvailableDates] = useState([])
  const [result, setResult] = useState([])
  const [filterType, setFilterType] = useState(BRAZILIAN_CREDIT_BONDS_TYPE[0])
  const [ipcaCurve, setIpcaCurve] = useState([])

  const { factBrazilianCreditBondsPrincingService, factIpcaCurve } = useService()

  useEffect(() => {
    factBrazilianCreditBondsPrincingService.getAvailableDates().then(setAvailableDates)
  }, [])

  useEffect(() => {
    availableDates && availableDates.length > 0 && !date && setDate(availableDates[0])
  }, [availableDates])

  useEffect(() => {
    if (!date || !filterType) return () => {}

    factBrazilianCreditBondsPrincingService.getFromDate(date, filterType.value).then(setResult)
  }, [date, filterType])

  useEffect(() => {
    if (!result || !result.length || !date || filterType.value !== BRAZILIAN_CREDIT_BONDS_TYPE[2].value) return setIpcaCurve([])

    factIpcaCurve.getCurveFrom(date).then((curve) => {
      const durations = result.map((item) => item.duration)
      const minDuration = Math.min(...durations)
      const maxDuration = Math.max(...durations)

      const points = []

      for (const point of curve) {
        const duration = point.tenor / 252
        if (duration < minDuration || duration > maxDuration) continue
        points.push({ duration, rate: point.rate })
      }

      console.log("points", points)

      setIpcaCurve(points)
    })
  }, [date, filterType, result])

  return {
    date,
    setDate,
    filterType,
    setFilterType,
    availableDates,
    result,
    ipcaCurve,
  }
}
